import { Component, OnInit, Input } from '@angular/core';
import { CompanyService } from 'app/company/services/company.service';
import { CompanyDetailsModel } from 'app/company/models/company-details-model';
import { CompanyAuditListModel } from 'app/company/models/company-audit-list.model';
import { Result } from 'app/core/models/result';

@Component({
    selector: 'app-company-audit-list',
    templateUrl: './company-audit-list.component.html',
    styleUrls: ['./company-audit-list.component.css']
})
export class CompanyAuditListComponent implements OnInit {
    errors: string[];
    audits: CompanyAuditListModel[];
    @Input() companyId: string;
    selectedId: string;
    companyDetailsModel: CompanyDetailsModel;

    constructor(
        private companyService: CompanyService
    ) {
    }

    ngOnInit() {
        this.loadAudits();
    }

    loadAudits(): void {
        this.companyService.getCompanyAudits(this.companyId).subscribe(
            audits => {
                this.audits = audits;
            },
            error => this.errors = error.errorList
        );
    }

    deleteCompanyAudit(): void {
        this.companyService.deleteCompanyAudit(this.selectedId).subscribe(
            result => this.loadAudits(),
            error => this.errors = (<Result>error).errorList
        );
    }
}
